module.exports = __webpack_public_path__ + "img/wa-gb-logo.4a6e40e9.webp";